import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  modalTitle: {
    marginBottom: '0px',
    padding: 8,
    fontSize: theme.size.lg,
    color: '#3C425B',
    background: 'white'
  },

  modalClose: {
    top: '24px',
    right: '24px',
    zIndex: 2
  },

  children: {
    overflow: 'hidden'
  },

  mobileChildren: {
    height: '100svh',
    maxHeight: 'unset'
  },

  root: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '40px',
    padding: '24px',
    overflow: 'hidden'
  },

  mobileRoot: {
    marginTop: '0',
    paddingTop: '0'
  },

  mobileTitle: {
    display: 'flex',
    alignItems: 'center',
    margin: '16px 0 22px 0',

    '& > span': {
      fontSize: theme.size.lg,
      color: '#1F1F1F'
    }
  },

  mobileBackArrow: {
    marginRight: '16px',
    cursor: 'pointer'
  },

  imageHolder: {
    '& .ReactCrop__child-wrapper': {
      maxWidth: '100%',
      maxHeight: '100%'
    },

    '& .ReactCrop__child-wrapper > img': {
      width: '100%',
      maxWidth: '450px',
      height: '100%'
    }
  },

  buttonArea: {
    position: 'sticky',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    margin: '16px -24px -24px -24px',
    height: '96px',
    paddingRight: '24px',
    background: '#F5F6F8',
    borderRadius: '0px 0px 8px 8px',

    '& > :first-child': {
      marginRight: '16px'
    }
  },

  buttonAreaMobile: {
    justifyContent: 'center',
    position: 'absolute',
    bottom: '0',
    left: '0',
    right: '0',
    margin: '0',
    height: 'auto',
    padding: '12px 24px',

    '& button': {
      flex: '1',
      maxWidth: '200px'
    }
  },

  button: {
    height: '48px'
  }
}))

export default useStyles
